import React, { useRef } from "react";

import { useEffect } from "react";
import { useState } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import DocumentHeader from "../../../components/document-header/document-header.componenet";
import DocumentBody from "../../../components/document-body/document-body.componenet";
import useFetchDocument from "../../../effects/use-fetch-document";
import { withRouter } from "react-router-dom";
import { authTokenSelector } from "../../../redux/user/user.reselect";
import { selectIsRefresh } from "../../../redux/refresh/refresh.reselect";
import { selectBoxNumber } from "../../../redux/document/document.reselect";

const BoxLabelDocument = ({
    authToken,
    match,
    isRefresh,
    boxNumber
}) => {
    
    const [dataIsReady, setDataIsReady] = useState(false);
    const [dataForDoucment, setDataForDoucment] = useState(null);

    const contentRef = useRef(null);
    const title = "Box Label";
    const path = "/salesorders";
    const subPath = "/boxlabels/doucments";

    const endpoint = `${path}/${match.params.uuid}${subPath}`;
    const endpointWitBoxNumber = `${endpoint}/${boxNumber}`
    const { data, error, isLoading } = useFetchDocument(
        endpointWitBoxNumber,
        authToken,
        isRefresh,
        boxNumber
    );

    useEffect(() => {
        setDataForDoucment({
            header: [
                data.company,
                data.salesOrderSummary
            ],
            body: {
                sections: [
                    data.customerWithShippingAddressSummary,
                    data.customerSummary
                ]
            }
        })
        setDataIsReady(true)
    }, [data])

    return (
        <>{dataIsReady &&
            <>
                <DocumentHeader
                    title={title}
                    hasMutliDocumnet={true}
                    endpointForSelect={`${path}/${match.params.uuid}/boxoptions`}
                    autTokenForSelect={authToken}
                    contentRef={contentRef}
                />
                <DocumentBody
                    title={title}
                    endpoint={endpoint}
                    contentRef={contentRef}
                    data={dataForDoucment}
                    tableColumns={false}
                    tableData={false}
                    error={error}
                    isLoading={isLoading}
                    watermark={false}
                />
            </>
        }
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    authToken: authTokenSelector,
    isRefresh: selectIsRefresh,
    boxNumber: selectBoxNumber
});

export default withRouter(connect(mapStateToProps, null)(BoxLabelDocument));
